import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigurationService } from "./../services/configuration.service"
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

export interface RESPONSE {
   error: string;
   status: number; 
   clientpdfpath: any;
   itrpdfpath: any;
   errorCode: string;
   errorDescription:string,
   Data: any
}

@Injectable({
  providedIn: 'root'
})
export class ApiRequestsService {
  private token: string = '';
  private baseURL = "http://localhost:3002/";
  //private baseURL = "http://192.168.0.183:3001/";

  public NO_ERROR = "000000";
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any> | undefined;

  constructor(private domSanitizer: DomSanitizer, private config: ConfigurationService, private HttpClient: HttpClient, private route: Router)
  {
    this.baseURL = this.config.getBaseUrl();
    this.currentUserSubject = new BehaviorSubject(null)
  }

  generateHeaderForAPIRequest = () => {
    return new HttpHeaders({ 'authorization': 'Bearer ' + this.token, "authfor": "W", });
  }

  getApiCall = (url: string, params: any = null) => {
    let httpHeaders = this.generateHeaderForAPIRequest();
    let httpParams = new HttpParams();
    if (params)
      httpParams = httpParams.append("criteria", params);
    return this.HttpClient.get(this.baseURL + url, { params: httpParams, headers: httpHeaders }).pipe(map((data: any) => {
      // ele.style.display="none";
      if (data["errorDescription"] && (data["errorDescription"].includes('Invalid token.') || data["errorDescription"].includes('Invalid user identifier'))) {
        console.log("Invalid token.");
        this.logout();
      }
      return data;
    }));
  }
  
  postApiCall = (url: string, params: any,checkToken:boolean=true) => {
    const ele: any = document.getElementById('loader-div');
    if (ele)
      ele.style.display = "block";
    const body: any = {};
    if (!params['criteria']) body['criteria'] = params;
    else body['criteria'] = params['criteria'];
    let httpHeaders = this.generateHeaderForAPIRequest();
    return this.HttpClient.post(this.baseURL + url, body, { headers: httpHeaders }).pipe(map((data: any) => {
      if (ele)
        ele.style.display = "none";
      if (checkToken && data["errorDescription"] && data["errorDescription"].includes('Invalid token.')) {
        console.log("Invalid token.");
        this.logout();
      }
      return data;
    }));
  }

  postApiCallReturningPromise = (url: string, body: object) => {
    return new Promise<RESPONSE>((resolve, reject) => {
      this.postApiCall(url, body).subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      });

    })
  }

  getAPICallReturningPromise = (url:string, body:string, responseType?: string) => {
    return new Promise<RESPONSE> ((resolve, reject) => {
      this.getApiCall(url, body).subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      });

    })
  }

  updateOrSetTokenValue = (newToken: string) => {
    this.token = newToken;
  }
  public set Token(token: string) {

  }
  public get Token(): string {
    return this.token;
  }

  uploadFile(file: any, endPoint: string, criteria = {}) {
    const fd = new FormData();
    fd.append('criteria', JSON.stringify(criteria));
    fd.append('localPath', file, file.name);
    console.log(fd);
    console.log(file, file.name);
    let httpHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + this.token,
      "authfor": "W"
    });
    httpHeaders.set('Content-type', 'multipart/form-data; boundary=1234567890xxxyyy104');
    return this.HttpClient.post(this.baseURL + endPoint, fd, { headers: httpHeaders });
  }


  // uploadFile(file: any, endPoint: string, criteria = {}) {
  //   const fd = new FormData();
  //   fd.append('criteria', JSON.stringify(criteria));
  //   fd.append('localPath', file, file.name);
    
  //   let httpHeaders = new HttpHeaders({
  //     'authorization': 'Bearer ' + this.token,
  //     "authfor": "W"
  //   });
    
  //   // This will track the upload progress
  //   return this.HttpClient.post(
  //     this.baseURL + endPoint, 
  //     fd, 
  //     { 
  //       headers: httpHeaders,
  //       reportProgress: true,
  //       observe: 'events'  // This is important to receive upload progress events
  //     }
  //   ).pipe(
  //     map((event: any) => {
  //       switch (event.type) {
  //         case HttpEventType.UploadProgress:
  //           // Calculate & return the upload percentage
  //           const progress = Math.round((100 * event.loaded) / event.total);
  //           return { status: 'progress', percentage: progress };
            
  //         case HttpEventType.Response:
  //           // Return the complete response when done
  //           return { status: 'complete', data: event.body };
            
  //         default:
  //           // Other events
  //           return { status: 'other' };
  //       }
  //     })
  //   );
  // }

  getImageSRC(imageSrc: string, defaultSrc: string = ''): any {

    return this.baseURL + 'uploads/' + imageSrc ? imageSrc : defaultSrc
  }

  loginsignup(params: any) {
    if (!params['criteria']) params['criteria'] = params;
    console.log(params,this.baseURL);

    return this.HttpClient.post(this.baseURL + "users/loginValidation", params)
    // .pipe(
    //   map((data:any) => {
    //     // console.log(data);

    //     if (data && data.Data.ntk) {
    //       // console.log(true);

    //       this._syncUser(data);
    //     }
    //     return data;
    //   }));
  }

  logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('currentUser');
    this.route.navigateByUrl("/login");
    this.currentUserSubject.next(null);
  }

  _syncUser(data: any) {
    // localStorage.setItem('currentUser', JSON.stringify(data));
    this.currentUserSubject.next(data);
  }
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  public set currentUserValue(data: any) {
    this.currentUserSubject.next(data);
  }
}
